import type {Service} from "./index";
export const productsCompany = ["CompanyLead", "Booking"] as const;
export type ProductsCompany = typeof productsCompany[number];
export type ProductsPrivate = "OnDemand" | "Booking" | "Package";
export type ProductType = ProductsCompany | ProductsPrivate;

/**
 * We sell different type of products (services) throughout our system,
 * which might differ in their behavior, but they share similarities as well.
 *
 * It describes a product that is provided to one of our customers (or many).
 */
export abstract class Product {
  public abstract readonly type: ProductType;
  service: Service;

  constructor(service: Service) {
    this.service = service;
  }
}
